import { useAuth } from "../../../context";
import { useMutation } from "react-query";
import { SupplierDecarbonizationPlanQuestionnaire } from "../../../api";

export function useCreateSupplierDecarbonizationPlanQuestionnaire(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(SupplierDecarbonizationPlanQuestionnaire.createSupplierDecarbonizationPlanQuestionnaire,
      { questionnaireId, data }), config);
}

export function useUpdateSupplierDecarbonizationPlanQuestionnaire(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, id, data }) =>
    callApi(SupplierDecarbonizationPlanQuestionnaire.updateSupplierDecarbonizationPlanQuestionnaire,
      { questionnaireId, id, data }), config);
}

export function useAttachDecarbonizationPlanDocumentation(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(SupplierDecarbonizationPlanQuestionnaire.attachDecarbonizationPlanDocumentation,
      { questionnaireId, data }), config);
}

export function useAttachLatestSustainabilityReport(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(SupplierDecarbonizationPlanQuestionnaire.attachLatestSustainabilityReport,
      { questionnaireId, data }), config);
}

export function useAttachDeforestationPlanDocumentation(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(SupplierDecarbonizationPlanQuestionnaire.attachDeforestationPlanDocumentation, { questionnaireId, data }), config);
}

export function useGetDecarbAttachment(config) {
  const { callApi } = useAuth();
  return useMutation(({ attachmentId, questionnaireId }) =>
    callApi(SupplierDecarbonizationPlanQuestionnaire.getDecarbAttachment, { attachmentId, questionnaireId }), config);
}

export function useDeleteDecarbAttachment(config) {
  const { callApi } = useAuth();
  return useMutation(({ attachmentId, questionnaireId }) =>
    callApi(SupplierDecarbonizationPlanQuestionnaire.deleteDecarbAttachment, {
      attachmentId,
      questionnaireId
    }), config);
}